import styled from '@emotion/styled';
import { Icon, Spin } from 'antd';
import React from 'react';

import { color } from 'src/shared/styles/variables';

const AntSpinnerIcon = styled(Icon)({
    fontSize: 32,
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
});

interface Props {
    delay?: number;
    iconColor?: string;
    fontSize?: number;
}

export const CenteredSpinner: React.SFC<Props> = ({
    delay = 0,
    iconColor = color.royalBlue,
    fontSize = 32,
}) => (
    <Spin
        delay={delay}
        indicator={
            <AntSpinnerIcon
                type="loading"
                spin
                data-testid="centered-spinner"
                style={{ color: iconColor, fontSize }}
            />
        }
    />
);
